import {CountriesOfOperationType} from "../RiskSettingsUtils"
import {CountriesFieldWithAllowUsOnlyToggleType} from "../../CountriesFieldWithAllowUsOnlyToggle/CountriesFieldWithAllowUsOnlyToggleUtils"
import {isEqualWith} from "lodash"
import React from "react"
import TitleWithBadge from "../../TitleWithBadge/TitleWithBadge"
import {isEqualAsSet} from "../../../utilities/set"

type ProhibitedCountriesTitleValueTypes = CountriesOfOperationType | CountriesFieldWithAllowUsOnlyToggleType | string[]

interface ProhibitedCountriesTitleProps {
	text: string
	value: ProhibitedCountriesTitleValueTypes
	defaultValue?: ProhibitedCountriesTitleValueTypes
}

export default function ProhibitedCountriesTitle({text, value, defaultValue}: ProhibitedCountriesTitleProps) {
	return (
		<TitleWithBadge
			title={text}
			showBadge={defaultValue ? !isEqualWith(value, defaultValue, isEqualAsSet) : undefined}
			badgeText="Exceptions"
			badgeTooltip={`This onboarding rules for this Org<br>
									include exceptions to the bank's<br>
									default onboarding rules.`}
			badgeTooltipClassname="risk-settings-badge-tooltip"
			badgeTooltipKey={`prohibited-countries-${text}-badge-tooltip"`}
			heading="h3"
		/>
	)
}
